import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../core/axios/axiosInstance";
import { useDispatch } from "react-redux";
import { fetchProfile } from "../../core/data/redux/slices/ProfileSlice";
import { all_routes } from "../router/all_routes";

const CopyLinkPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const route = all_routes;

    const encodedUrl = searchParams.get("url");
    const url = encodedUrl ? decodeURIComponent(encodedUrl) : null;

    console.log("Encoded URL:", encodedUrl);
    console.log("Decoded URL:", url);
    console.log("Received magic link URL:", url); // Debug log

    const [message, setMessage] = useState("Processing your login...");
    const [subMessage, setSubMessage] = useState(
        "Please wait while we securely log you in."
    );
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    // 🔥 MAIN AUTO LOGIN FLOW
    // useEffect(() => {
    //     const handleMagicLogin = async () => {
    //         try {
    //             if (!url) {
    //                 throw new Error("Invalid or missing magic link");
    //             }

    //             console.log("Decoded URL:", url);

    //             // ✅ Copy link (ignore error silently)
    //             try {
    //                 await navigator.clipboard.writeText(url);
    //             } catch (e) {
    //                 console.log("Clipboard failed (safe to ignore)");
    //             }

    //             // ✅ CALL API
    //             const res = await api.post("/user/login/magic-link", {
    //                 magicLink: url,
    //             });

    //             console.log("API RESPONSE:", res.data);

    //             if (res.data.status !== "success") {
    //                 throw new Error("Login failed");
    //             }

    //             // ✅ Save token
    //             localStorage.setItem("token", res.data.data.token);

    //             setMessage("Login successful ✅");
    //             setSubMessage("Redirecting to dashboard...");
    //             setLoading(false);

    //             // ✅ Fetch profile (optional safe)
    //             try {
    //                 await dispatch(fetchProfile());
    //             } catch (e) {
    //                 console.log("Profile fetch failed (ignored)");
    //             }

    //             // ✅ REDIRECT (NO DELAY)
    //             navigate(route.dashboard);

    //         } catch (err) {
    //             console.error("Magic login failed:", err?.response?.data || err.message);

    //             setMessage(
    //                 err?.response?.data?.message || "Magic link login failed"
    //             );
    //             setSubMessage("Please click below to login manually.");
    //             setLoading(false);
    //             setError(true);
    //         }
    //     };

    //     handleMagicLogin();
    // }, [url, dispatch, navigate, route.dashboard]);

    useEffect(() => {
        if (!url) {
            setMessage("Invalid or missing magic link");
            setSubMessage("");
            setLoading(false);
        } else {
            setMessage("Click below to login securely");
            setSubMessage("Your magic link is ready.");
            setLoading(false);
        }
    }, [url]);

    // 🔥 MANUAL LOGIN BUTTON (fallback)
    const handleManualLogin = async () => {
        try {
            if (!url) {
                alert("Invalid magic link");
                return;
            }

            setLoading(true);

            const res = await api.post("/user/login/magic-link", {
                magicLink: url,
            });

            console.log("Manual login response:", res.data);

            if (res.data.status !== "success") {
                throw new Error("Login failed");
            }

            // ✅ Save token
            localStorage.setItem("token", res.data.data.token);

            // ✅ Fetch profile
            await dispatch(fetchProfile());

            // ✅ Redirect
            window.location.href = route.dashboard;

        } catch (err) {
            console.error("Manual login error:", err?.response?.data || err.message);
            alert("Login failed. Please try again.");
            setLoading(false);
        }
    };

    return (
        <div className="vh-100 d-flex flex-column justify-content-center align-items-center text-center">

            {loading && (
                <div className="spinner-border text-primary mb-4" role="status" />
            )}

            <h5 className="fw-semibold">{message}</h5>

            {subMessage && <p className="text-muted mb-3">{subMessage}</p>}

            {/* 🔥 SHOW LINK (for manual copy fallback) */}
            {url && (
                <input
                    type="text"
                    value={url}
                    readOnly
                    className="form-control mb-3"
                    style={{ maxWidth: "400px" }}
                />
            )}

            {/* 🔥 COPY BUTTON */}
            {url && (
                <button
                    className="btn btn-outline-primary mb-2"
                    onClick={() => navigator.clipboard.writeText(url)}
                >
                    Copy Link
                </button>
            )}

            {/* 🔥 LOGIN BUTTON (fallback if auto fails) */}
            {/* {error && (
                <button
                    className="btn btn-primary"
                    onClick={handleManualLogin}
                >
                    Login to Dashboard
                </button>
            )} */}

            <button
                className="btn btn-primary"
                onClick={handleManualLogin}
                disabled={loading}
            >
                {loading ? "Processing..." : "Login to Dashboard"}
            </button>

        </div>
    );
};

export default CopyLinkPage;